export function mapSaintToFormInitial(data) {
  return {
    ...data,
    beatifiedISO: data?.beatifiedText || "",
    canonizedISO: data?.canonizedText || "",
    // optionally: convert legacy country values to select value
    countryValue: data?.countryLower || "",
  };
}
